import {Injectable} from '@angular/core';
import { Observable } from 'rxjs-compat';
import { AddressManager } from 'src/app/data/manager/customer/address/address.manager';
import { CustomerManager } from '../../data/manager/customer/customer/customer.manager';

@Injectable({
  providedIn: 'root',
})
export class AddressSelectVm {
  constructor( private customerManager: CustomerManager, private addressManager: AddressManager ) { }

  isLogin() {
    return this.customerManager.hasValidCustomer();
  }

  getAddressUser(): Observable<any> {
    return this.addressManager.get();
  }

  observableLogin(): Observable<any> {
    return this.customerManager.hasCustomer();
  }
}
